/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebrevieweyebrow3Inputs */

const en_placewebrevieweyebrow3 = /** @type {(inputs: Placewebrevieweyebrow3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review`)
};

const de_placewebrevieweyebrow3 = /** @type {(inputs: Placewebrevieweyebrow3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfen`)
};

/**
* | output |
* | --- |
* | "Review" |
*
* @param {Placewebrevieweyebrow3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebrevieweyebrow3 = /** @type {((inputs?: Placewebrevieweyebrow3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebrevieweyebrow3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebrevieweyebrow3(inputs)
	return de_placewebrevieweyebrow3(inputs)
});
export { placewebrevieweyebrow3 as "placeWebReviewEyebrow" }